import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import _ from "lodash";
import { alpha, makeStyles } from "@material-ui/core/styles";

import { FormControl, Select, Grid } from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import InputBase from "@material-ui/core/InputBase";
import { searchVMProducts } from "redux/actions";

let timeoutId;
export default function SearchBar() {
  const themeData = useSelector((state) => state.touchless.theme);

  const {
    name,
    primary_color = "#defaultPrimaryColor",
    secondary_color = "#defaultSecondaryColor",
    text_button_color = "#defaultTextColor",
    background_img_url = "../../../assets/images/defaultBackground.png",
    item_background_img_url = "../../../assets/images/defaultItemBackground.png",
    background_opacity = "defaultOpacity",
    item_background_opacity = "defaultItemOpacity",
} = themeData || {};

  const useStyles = makeStyles((theme) => ({
    root: {
      padding: "1em 1em 0.4em 0.5em",
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      flexGrow: 1,
    },
    input: {
      color: theme.palette.primary.main,
      fontFamily: "Ubuntu",
      backgroundColor: alpha(theme.palette.common.white, 0.5),
      borderRadius: 20,
      width: "100%",
      "& ::placeholder": {
        // color: "#1451F6",
        color: name==="default"?"#1451F6":secondary_color,
        fontWeight: "bold",
        fontFamily: "Ubuntu",
      },
  
      "& input": {
        padding: "8px 12px",
        color: theme.palette.primary.main,
        fontFamily: "Ubuntu",
      },
      "& .MuiOutlinedInput-root": {
        borderRadius: 20,
      },
    },
  
    search: {
      position: "relative",
      height: 40,
      borderRadius: 20,
      // color: "#1451F6",
      color: name==="default"?"#1451F6":secondary_color,
      backgroundColor: alpha(theme.palette.common.white, 0.5),
      "&:hover": {
        backgroundColor: alpha(theme.palette.common.white, 0.25),
      },
      marginLeft: 0,
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "auto",
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: "100%",
      position: "absolute",
      pointerEvents: "none",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    inputRoot: {
      color: "inherit",
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create("width"),
      width: "100%",
    },
    select: {
      "&:before": {
        borderColor: "#1451F6",
      },
      "&:after": {
        borderColor: "#1451F6",
      },
    },
    icon: {
      fill: "#1451F6",
    },
    options:{
      color:name==="default"?"#1451F6":secondary_color
    }
  }));

  const classes = useStyles();
  const [selectedCategory, setSelectedCategory] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const categories = useSelector((state) => state.touchless.categories);
  const dispatch = useDispatch();

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const serial_no = urlParams.get("serial_no");

 
  return (
    <Grid container spacing={2} alignItems="center" className={classes.root}>
      <Grid item xs={7} sm={8} md={9}>
        <FormControl
          variant="outlined"
          fullWidth
          required
          size="small"
          className={classes.input}
        >
          {name==="default"?      
           <Select
            native
            variant="outlined"
            value={selectedCategory}
            onChange={(e) => {
              const value = e.target.value;

              dispatch(searchVMProducts(searchQuery, value, serial_no))
              setSelectedCategory(value);
            }}
            key="vendor"
            fullWidth
            required
            style={{ color: "#1451F6", fontWeight: "bold" }}
            className={classes.select}
            inputProps={{
              classes: {
                icon: classes.icon,
              },
            }}
          >
            <option value="">Filter by category</option>
            {_.map(categories, (label, keyName) => {
              return (
                <option key={keyName} value={keyName}>
                  {label}
                </option>
              );
            })}
          </Select> :          
          <Select
            native
            variant="outlined"
            value={selectedCategory}
            onChange={(e) => {
              const value = e.target.value;

              dispatch(searchVMProducts(searchQuery, value, serial_no))
              setSelectedCategory(value);
            }}
            key="vendor"
            fullWidth
            required
            style={{ color: secondary_color, fontWeight: "bold" }}
            className={classes.select}
            inputProps={{
              classes: {
                icon: classes.icon,
              },
            }}
          
          >
            <option value="">Filter by category</option>
            {_.map(categories, (label, keyName) => {
              return (
                <option key={keyName} value={keyName} className={classes.options}>
                  {label}
                </option>
              );
            })}
          </Select>}

        </FormControl>
      </Grid>
      <Grid item xs={5} sm={4} md={3}>
        <div className={classes.search}>
          <div className={classes.searchIcon}>
            <SearchIcon />
          </div>
          <InputBase
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
            placeholder="Search"
            onChange={(e) => {
              const value = e.target.value;

              clearTimeout(timeoutId);

              timeoutId = setTimeout(() => {
                dispatch(searchVMProducts(value, selectedCategory, serial_no))
              }, 200);

              setSearchQuery(value);
            }}
            value={searchQuery}
            inputProps={{ "aria-label": "search" }}
          />
        </div>
      </Grid>
    </Grid>
  );
}
